import LoadingHomeRate from './LoadingHomeRate';

// export { TextProps } from './LoadingHomeRate';
export default LoadingHomeRate;
